import React from 'react';
import { Button, Row, Col, Typography, Space } from 'antd';
import { AppleOutlined, AndroidOutlined, GlobalOutlined } from '@ant-design/icons';
import iosQRCode from '../assets/https___apps.apple.com_cn_app_lifeano_id1602340143.png';
import googlePlayQRCode from '../assets/https___play.google.com_store_apps_details_id=com.lcm.lifeano.png';
import androidQRCode from '../assets/https___d2631ameks0q51.cloudfront.net_lif_394_0311_stripe.apk.png';  // 添加这行
import OptimizedImage from './OptimizedImage';

const { Title, Paragraph } = Typography;

const DownloadSection = () => {
  return (
    <div style={{ textAlign: 'center', padding: '40px 0' }}>
      <Title>下载 Lifeano</Title>
      <Paragraph style={{ fontSize: '16px', marginBottom: '40px' }}>
        多平台支持，为您提供最佳体验
      </Paragraph>
      
      <Row gutter={[24, 24]} justify="center">
        <Col xs={24} sm={12} md={8}>
          <Space direction="vertical" style={{ width: '100%' }}>
            <OptimizedImage 
              src={iosQRCode}
              alt="iOS 版本 Lifeano APP 下载二维码" 
              style={{ width: '150px', marginBottom: '8px' }}
            />
            <Paragraph style={{ marginBottom: '16px', fontSize: '16px' }}>
              iOS 版本 (Apple Pay 支付)
            </Paragraph>
            <a href="https://apps.apple.com/cn/app/lifeano/id1602340143" target="_blank" rel="noopener noreferrer" style={{ width: '100%' }}>
              <Button type="primary" size="large" icon={<AppleOutlined />} block>
                App Store 市场下载
              </Button>
            </a>
          </Space>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Space direction="vertical" style={{ width: '100%' }}>
            <img 
              src={googlePlayQRCode}
              alt="Google Play QR Code" 
              style={{ width: '150px', marginBottom: '8px' }}
            />
            <Paragraph style={{ marginBottom: '16px', fontSize: '16px' }}>
              Android 版本 (Google Play 支付)
            </Paragraph>
            <a href="https://play.google.com/store/apps/details?id=com.lcm.lifeano" target="_blank" rel="noopener noreferrer" style={{ width: '100%' }}>
              <Button type="primary" size="large" icon={<AndroidOutlined />} block>
                Google Play 市场下载
              </Button>
            </a>
          </Space>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Space direction="vertical" style={{ width: '100%' }}>
            <img 
              src={androidQRCode}
              alt="Android QR Code" 
              style={{ width: '150px', marginBottom: '8px' }}
            />
            <Paragraph style={{ marginBottom: '16px', fontSize: '16px' }}>
              Android 版本 (通用支付)
            </Paragraph>
            <a href="https://d2631ameks0q51.cloudfront.net/lif_394_0311_stripe.apk" target="_blank" rel="noopener noreferrer" style={{ width: '100%' }}>
              <Button type="primary" size="large" icon={<AndroidOutlined />} block>
                通用安卓 APK 下载
              </Button>
            </a>
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default DownloadSection;